import React from 'react';
import { Button } from '../ui/Button';
import { SelectField, TextAreaField, TextField } from '../ui/Field';
import { FormCard, FormError, FormFooterNote, FormSuccess } from './FormShell';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';

/**
 * Formulario exclusivo de simulación de crédito hasta el 100%.
 * Se guarda en la hoja "Financiación" con las respuestas detalladas.
 */
export function SimulacionCreditoForm({
  vehiculoInicial = ''
}: {
  vehiculoInicial?: string;
}) {
  const {
    status,
    sending,
    submitted,
    reference,
    submitForm,
    retry
  } = useLeadSubmit('simulacion', 'Financiación');
  if (submitted) {
    return <FormSuccess message="Gracias por tu consulta. Un asesor de VCARS se comunicará con vos a la brevedad." reference={reference} data-id="element-145" data-mp="2fbs135bi6mgz" />;
  }
  return <FormCard title="Simulá tu crédito hasta el 100%" lead="Respondé estas preguntas y evaluamos tu perfil para armar una simulación real, sin compromiso." data-id="element-146" data-mp="dgzviiglz831">
      {status === 'error' ? <FormError onRetry={retry} data-id="element-147" data-mp="19uwg3spzhyv8" /> : null}
      <form className="grid gap-4 sm:grid-cols-2" onSubmit={submitForm} data-id="element-148" data-mp="19y0neyyqxaq4">
        <TextField id="nombre" label="Nombre y apellido" required autoComplete="name" data-id="element-149" data-mp="1ew2arw37fw7e" />
        <TextField id="telefono" label="Teléfono" type="tel" required autoComplete="tel" data-id="element-150" data-mp="10wkeywrhrioj" />
        <TextField id="email" label="Email" type="email" required autoComplete="email" data-id="element-151" data-mp="15uvr5e59e59x" />
        <TextField id="cuil" label="CUIL" required inputMode="numeric" pattern="[0-9\-\s]{11,13}" maxLength={13} placeholder="20-12345678-3" title="Ingresá los 11 números de tu CUIL" data-id="element-152" data-mp="1tkq2tsdudnsl" />

        <SelectField id="anticipoPermuta" label="¿Tenés anticipo o permuta?" options={['Tengo anticipo en efectivo', 'Tengo un vehículo para permutar', 'Tengo anticipo y permuta', 'No tengo anticipo ni permuta']} required data-id="element-153" data-mp="1osf1cl3gdtxx" />
        <SelectField id="clienteBancario" label="¿Sos cliente activo bancario?" options={['Sí, con cuenta y movimientos', 'Sí, pero sin movimientos', 'No', 'No estoy seguro']} required data-id="element-154" data-mp="2r3x0atdjcx3o" />
        <SelectField id="simular100" label="¿Querés simular un crédito hasta el 100%?" options={['Sí, hasta el 100%', 'Prefiero financiar una parte', 'Quiero que me asesoren']} required data-id="element-155" data-mp="2h8v9zu7ixozi" />
        <SelectField id="garante" label="¿Contás con garante si la simulación es rechazada?" options={['Sí, tengo garante', 'No tengo garante', 'Puedo conseguirlo']} required data-id="element-156" data-mp="23f3yiga8fv15" />
        <SelectField id="continuar" label="Si la simulación es aprobada, ¿querés que VCARS te contacte?" options={['Sí, quiero continuar', 'Sí, pero más adelante', 'Solo quiero información']} required className="sm:col-span-2" data-id="element-157" data-mp="1tisjhij9cr30" />

        <TextField id="vehiculoInteres" label="Vehículo de interés (opcional)" defaultValue={vehiculoInicial} placeholder="Ej: Toyota Corolla Cross 0KM" className="sm:col-span-2" data-id="element-158" data-mp="3w33b8s6g9c5i" />
        <TextAreaField id="mensaje" label="Comentarios adicionales" className="sm:col-span-2" placeholder="Contanos cualquier dato que nos ayude a evaluar tu perfil." data-id="element-159" data-mp="8xcbmbt1q164" />

        <div className="sm:col-span-2" data-id="element-160" data-mp="3hf8gl68vsxps">
          <Button type="submit" size="lg" className="w-full sm:w-auto" disabled={sending} data-id="element-161" data-mp="3hga5oemqfkqi">
            {sending ? 'Enviando simulación…' : 'Simular mi crédito'}
          </Button>
          <FormFooterNote data-id="element-162" data-mp="3r5jyxxtbb9g7">
            La simulación no tiene costo ni compromiso. Te acompañamos durante toda la
            operación.
          </FormFooterNote>
        </div>
      </form>
    </FormCard>;
}